export type Position = {
  order: number;
  startLat: number;
  startLng: number;
  endLat: number;
  endLng: number;
  arcAlt: number;
  color: string;
};

export type GlobeConfig = {
  pointSize?: number;
  globeColor?: string;
  showAtmosphere?: boolean;
  atmosphereColor?: string;
  atmosphereAltitude?: number;
  emissive?: string;
  emissiveIntensity?: number;
  shininess?: number;
  polygonColor?: string;
  ambientLight?: string;
  directionalLeftLight?: string;
  directionalTopLight?: string;
  pointLight?: string;
  arcTime?: number;
  arcLength?: number;
  rings?: number;
  maxRings?: number;
  initialPosition?: { lat: number; lng: number };
  autoRotate?: boolean;
  autoRotateSpeed?: number;
};

/** 示例飞线数据（红黑主题色） */
export const SAMPLE_ARCS: Position[] = [
  { order: 1, startLat: 39.9042, startLng: 116.4074, endLat: 40.7128, endLng: -74.006, arcAlt: 0.4, color: '#ff2e4d' },
  { order: 1, startLat: 39.9042, startLng: 116.4074, endLat: 51.5072, endLng: -0.1276, arcAlt: 0.3, color: '#ff5c75' },
  { order: 2, startLat: 31.2304, startLng: 121.4737, endLat: -33.8688, endLng: 151.2093, arcAlt: 0.3, color: '#ff8a9e' },
  { order: 2, startLat: 22.3193, startLng: 114.1694, endLat: 37.7749, endLng: -122.4194, arcAlt: 0.5, color: '#e11d2e' },
  { order: 3, startLat: 35.6762, startLng: 139.6503, endLat: 48.8566, endLng: 2.3522, arcAlt: 0.3, color: '#ff2e4d' },
  { order: 3, startLat: 1.3521, startLng: 103.8198, endLat: 25.2048, endLng: 55.2708, arcAlt: 0.3, color: '#ff5c75' },
  { order: 4, startLat: 51.5072, startLng: -0.1276, endLat: 35.6762, endLng: 139.6503, arcAlt: 0.3, color: '#ff8a9e' },
  { order: 4, startLat: 40.7128, startLng: -74.006, endLat: 37.7749, endLng: -122.4194, arcAlt: 0.2, color: '#e11d2e' },
  { order: 5, startLat: 48.8566, startLng: 2.3522, endLat: 52.52, endLng: 13.405, arcAlt: 0.15, color: '#ff2e4d' },
  { order: 5, startLat: 55.7558, startLng: 37.6173, endLat: 39.9042, endLng: 116.4074, arcAlt: 0.4, color: '#ff5c75' },
  { order: 6, startLat: 22.3193, startLng: 114.1694, endLat: 51.5072, endLng: -0.1276, arcAlt: 0.4, color: '#ff8a9e' },
  { order: 6, startLat: -33.8688, startLng: 151.2093, endLat: 1.3521, endLng: 103.8198, arcAlt: 0.3, color: '#e11d2e' },
];
